const Roles = {
  donor: 'donor',
  admin: 'admin',
  applicant: 'applicant',
};

export default Roles;
